import React from 'react';
import logo from '../logo/usf_logo.jpeg';

const Invoice = (data) => {
    console.log(data.data, "data");

    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    const formattedToday = `${dd}/${mm}/${yyyy}`;


    return (
        <div>
            <style>
                {`
                table, th, td {
                    border: 1px solid #000;
                    border-collapse: collapse;
                    padding: 2px !important;
                    font-size: 11px !important;
                    font-weight: 900 !important;
                    height: 0px !important;
                    color: #000 !important;
                }
                th{
                    text-align: center
                }
                .f-14{
                    font-size: 14px !important;
                }
                .bt {
                    border-top: none !important;
                }
                .bb {
                    border-bottom: none !important;
                }
                .bl {
                    border-left: none !important;     
                }
                .br {
                    border-right: none !important;
                }
                .bold{
                    font-weight: 900;
                }
                .w-20{
                    width: 20%;
                }
                .w-10{
                    width: 10%;
                }
                .tr tr {
                    height: 12px;
                }
                `}
            </style>
            <div style={{ width: "99%" }}>
                <h1 style={{ fontSize: '16px', textAlign: 'center' }}>TAX INVOICE</h1>

                <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                    <colgroup>
                        <col style={{ width: '20%' }} /> {/* Logo */}
                        <col style={{ width: '30%' }} /> {/* Company details */}
                        <col style={{ width: '25%' }} /> {/* Invoice no */}
                        <col style={{ width: '25%' }} /> {/* Invoice date */}
                    </colgroup>
                    <tbody>
                        <tr>
                            {/* Left 50% */}
                            <td rowSpan="3" className="br" style={{ textAlign: 'center' }}>
                                <img src={logo} style={{ width: '80%', maxWidth: '120px' }} />
                            </td>
                            <td rowSpan="3" className="text-start bl" style={{ paddingLeft: '8px', fontSize: '14px' }}>
                                <strong>ULTRA SURFACE FINISHERS</strong>
                                <br />
                                NO:3, WELFARE SCHOOL STREET,
                                <br />
                                AYANAMBAKKAM,
                                <br />
                                CHENNAI - 600095
                                <br />
                                PH: 9884565830,9884043474
                                <br />
                                E-MAIL: usfchennai@gmail.com
                                <br />
                                GSTIN: 33AJWPP0088Q1Z9
                            </td>

                            {/* Right 50% */}
                            <td>
                                Invoice No
                                <br />
                                <strong>{data.data?.[0]?.invoiceNo}</strong>
                            </td>
                            <td>
                                Invoice Date
                                <br />
                                <strong>{data?.data?.[0]?.date &&
                                    data.data[0].date.split("T")[0].split("-").reverse().join("-")
                                }
                                </strong>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                Purchase Order No.
                                <br />
                                <strong>{data.data?.[0]?.orderNo || '--'}</strong>
                            </td>
                            <td>
                                Vendor Code
                                <br />
                                <strong>{data.data?.[0]?.vendorCode || '--'}</strong>
                            </td>
                        </tr>

                        <tr>
                            <td className="br">
                                SAC Code
                                <br />
                                <strong>998898</strong>
                            </td>
                            <td className="bl"></td>
                        </tr>

                        <tr>
                            <td rowSpan="3" className="text-start br" style={{ marginLeft: '12px' }} colSpan="2">
                                <strong>BILL TO:</strong>
                                <br />
                                <strong>{data.data?.[0]?.companyName}</strong>
                                <br />
                                {data.data?.[0]?.doorNo}
                                <br />
                                {data.data?.[0]?.streetName}
                                <br />
                                {data.data?.[0]?.city} - {data.data?.[0]?.pinCode}
                                <br />
                                GST No. {data.data?.[0]?.gstNo}
                            </td>
                        </tr>
                    </tbody>
                </table>


                <table style={{ width: '100%', marginTop: '12px' }}>
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>USF DC NO.</th>
                            <th>DATE</th>
                            <th>COMPONENTS</th>
                            <th>CUSTOMER DC NO.</th>
                            <th>QTY (NOS/KGS)</th>
                            <th>RATE</th>
                            <th>AMOUNT</th>
                        </tr>
                    </thead>

                    <tbody style={{ minHeight: "360px" }} className="tr">
                        {data.data?.[0]?.invoiceData?.map((row, index) => (
                            <tr key={index}>
                                <td className="text-center bb bt">{index + 1}</td>
                                <td className="text-center bb bt">{row?.usfDCNo || ''}</td>
                                <td className="text-center bb bt">{row?.usfDcDate
                                    ? row.usfDcDate.split("T")[0].split("-").reverse().join("-")
                                    : ""}
                                </td>
                                <td className="bb bt" style={{ width: "20%", whiteSpace: "pre-line" }}>
                                    {row?.partName || ''} - {row?.partNo || ''} - {row?.description || ''}
                                </td>
                                <td className="text-center bb bt">{row?.customerDCNo || ''}</td>
                                <td className="text-center bb bt">{row?.invoiceQuantity || ''} ({row?.units})</td>
                                <td className="text-center bb bt">
                                    {row?.rate != null ? Number(row.rate).toFixed(2) : ''}
                                </td>
                                <td className="text-end bb bt">{row?.amount !== undefined ? Number(row.amount).toFixed(2) : ''}</td>
                            </tr>
                        ))}

                        {/* Fill empty rows to maintain the height */}
                        {Array.from({ length: Math.max(0, 19 - (data.data?.[0]?.invoiceData?.length || 0)) }).map(
                            (_, index) => (
                                <tr key={`empty-${index}`}>
                                    <td className="text-center bb bt">&nbsp;</td>
                                    <td className="text-center bb bt">&nbsp;</td>
                                    <td className="text-center bb bt">&nbsp;</td>
                                    <td className="bb bt">&nbsp;</td>
                                    <td className="text-center bb bt">&nbsp;</td>
                                    <td className="text-center bb bt">&nbsp;</td>
                                    <td className="text-center bb bt">&nbsp;</td>
                                    <td className="text-end bb bt">&nbsp;</td>
                                </tr>
                            )
                        )}
                    </tbody>

                    <tbody>
                        <tr>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'>Total Amount</td>
                            <td className='text-end bb bt'><strong>{data.data?.[0]?.totalAmount !== undefined
                                ? Number(data.data[0].totalAmount).toFixed(2)
                                : ''}</strong></td>
                        </tr>
                        <tr>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className="bb bt">
                                {new Date(data?.data?.[0]?.date) < new Date("2025-09-22")
                                    ? "CGST Outward 6%"
                                    : "CGST Outward 9%"}
                            </td>

                            <td className='text-end bb bt'>
                                {data.data?.[0]?.cgst != null ? Number(data.data[0].cgst).toFixed(2) : ''}
                            </td>
                        </tr>
                        <tr>
                            <td className='bb bt'></td>
                            <td className='text-end bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className="bb bt">
                                {new Date(data?.data?.[0]?.date) < new Date("2025-09-22")
                                    ? "SGST Outward 6%"
                                    : "SGST Outward 9%"}
                            </td>

                            <td className='text-end bb bt'>{data.data?.[0]?.sgst != null ? Number(data.data[0].sgst).toFixed(2) : ''}</td>
                        </tr>
                        <tr>
                            <td className='bb bt'></td>
                            <td className='text-end bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className="bb bt">
                                {new Date(data?.data?.[0]?.date) < new Date("2025-09-22")
                                    ? "IGST Outward 12%"
                                    : "IGST Outward 18%"}
                            </td>

                            <td className='text-end bb bt'>{data.data?.[0]?.igst != null ? Number(data.data[0].igst).toFixed(2) : ''}</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className='text-center'><strong>{data.data?.[0]?.totalQuantity}</strong></td>
                            <td><strong>Grand Total Amount</strong></td>
                            <td className='text-end'><strong>₹. {data.data?.[0]?.grandTotal != null ? Number(data.data[0].grandTotal).toFixed(2) : ''}</strong></td>
                        </tr>
                        <tr>
                            <td colSpan="8">
                                Tax Amount (in words):
                                <br />
                                <strong>{data.data?.[0]?.grandTotalInWords?.toUpperCase() || ""} ONLY</strong>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table style={{ width: '100%', marginTop: '2px' }}>
                    <tbody>
                        <tr>
                            <td colSpan="3" style={{ width: '50%' }} className='bt br bb'>
                                <strong>Company's GST No.</strong> : 33AJWPP0088Q1Z9<br />
                                <strong>Company's PAN No.</strong> : AJWPP0088Q
                            </td>
                            <td colSpan="4" className='bt bl'>
                                <strong>Company's Bank Details</strong>
                                <br />
                                <strong>Bank Name :</strong> INDIAN OVERSEAS BANK<br /> (NOLAMBUR BRANCH)
                                <br />
                                <strong>A/c No. :</strong> 213902000100020
                                <br />
                                <strong>Branch & IFS Code :</strong> IOBA0002139
                            </td>
                        </tr>

                        <tr>
                            <td colSpan="3" className='bt'>
                                <strong>Declaration</strong>
                                <br />
                                We declare that this invoice shows the actual price of the goods<br /> described and that all particulars are true and correct.
                            </td>
                            <td colSpan="4" style={{ height: '56px' }}>
                                <strong>
                                    <p>FOR ULTRA SURFACE FINISHERS</p>

                                    <br />
                                    Authorised Signatory
                                </strong>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p className='f-13 text-center mt-2 text-bold'>This is a computer Generated Invoice</p>
            </div>
        </div>
    );
};

export default Invoice;
